<template>
    <div id="page" v-show="show" v-loading.fullscreen.lock="fullscreenLoading">
        <loginArea v-if="!login"></loginArea>
        <div class="wrapper" id="siteWrapper" v-if="login">
            <header class="main-header">
                <a href="/#" class="logo">
                    HR融担平台
                </a>
                <nav class="navbar navbar-static-top">
                    <a href="#" class="sidebar-toggle" data-toggle="offcanvas" title="展开边栏" role="button">
                        <span class="sr-only">展开边栏</span>
                    </a>
                    <ul class="nav navbar-nav hidden-xs">
                        <li :class="areaName == 'home'?'active':''" v-if="(role_oper_type==2||role_oper_type==3)">
                            <router-link to="/homePage"><i class="fa fa-home"></i> &nbsp;主页</router-link>
                        </li>
                        <!-- 车贷 -->
                        <li v-if="top_chedaiTab" :class='{"active":(areaName == "chedai")}'>
                            <router-link :to="top_chedaiTab.href">
                                <i :class="top_chedaiTab.icon"></i>&nbsp;{{ top_chedaiTab.name }}
                            </router-link>
                        </li>

                        <li v-if="topAdminTab" :class='{"active":(areaName == "erp")}'>
                            <router-link :to="topAdminTab.href">
                                <i :class="topAdminTab.icon"></i> &nbsp;{{ topAdminTab.name }}
                            </router-link>
                        </li>
                        <!-- 系统 -->
                        <li v-if="topCarTab" :class='{"active":(areaName == "car")}'>
                            <router-link :to="topCarTab.href">
                                <i :class="topCarTab.icon"></i> &nbsp;{{ topCarTab.name }}
                            </router-link>
                        </li>
                        <li v-if="topFastDebit" :class='{"active":(areaName == "csd")}'>
                            <router-link :to="topFastDebit.href">
                                <i :class="topFastDebit.icon"></i> &nbsp;{{ topFastDebit.name }}
                            </router-link>
                        </li>
                        <li v-if="topBackTab"><a href="#"><i class="fa fa-reply"></i> &nbsp;返回</a></li>
                    </ul>
                    <div class="navbar-custom-menu">
                        <ul class="nav navbar-nav">
                            <li v-if="topTodo">
                                <router-link :to="topTodo.href">
                                    {{ topTodo.name }} &nbsp; <i :class="topTodo.icon"></i>
                                    <span class="label label-danger">{{ taskCount }}</span>
                                </router-link>
                            </li>
                            <li v-if="topMsg">
                                <router-link :to="topMsg.href">
                                    {{ topMsg.name }} &nbsp; <i :class="topMsg.icon"></i>
                                    <span class="label label-danger">{{ msgCount }}</span>
                                </router-link>
                            </li>
                            <li id="infoCounter" v-if="topNotify">
                                <router-link to="/user/taskNotify">
                                    估价提醒 &nbsp; <i class="fa fa-bell-o"></i>
                                    <span class="label label-success">{{ priceCount }}</span>
                                </router-link>
                            </li>
                            <li class="dropdown user user-menu">
                                <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                    <img src="static/img/avatar.png" class="user-image" :alt="user.name">
                                    <span class="hidden-xs">{{ user.name }}</span>
                                </a>
                                <ul class="dropdown-menu">
                                    <li class="user-header">
                                        <img src="static/img/avatar.png" class="img-circle" :alt="user.name">
                                        <p>
                                            {{ user.name }}
                                            <small>{{ user.depart_name }} - {{ user.role_name }}</small>
                                        </p>
                                    </li>
                                    <!-- Menu Footer-->
                                    <li class="user-footer">
                                        <div class="pull-left">
                                            <router-link to="/user/info" class="btn btn-default btn-flat">个人资料
                                            </router-link>
                                        </div>
                                        <div class="pull-right">
                                            <a href="javascript:;" class="btn btn-default btn-flat"
                                               @click.stop="userSignOut">退出</a>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header>
            <aside class="main-sidebar">
                <sidebarArea :sideparamas="areaName"></sidebarArea>
            </aside>
            <router-view class="content-wrapper"></router-view>
<!--            <footer class="main-footer">-->
<!--                <div class="pull-right hidden-xs" :title="version">-->
<!--&lt;!&ndash;                      <b>Version</b> {{viewVer}}&ndash;&gt;-->
<!--                    <b> &nbsp; </b>-->
<!--                </div>-->
<!--            </footer>-->
        </div>
        <createWin :visible="showCreateWin" @closed="showCreateWin = false"></createWin>
        <createFile :visible="showCreateFile" @closed="showCreateFile = false"></createFile>
    </div>
</template>

<script>
    import $ from 'jquery'
    import 'bootstrap'
    import 'jquery-slimscroll'
    import _ from 'lodash'
    import loginArea from './part/system/login'
    import sidebarArea from './part/system/menu'
    import createWin from './part/system/createWin'
    import _this from './lib/common/user'
    import _msg from './lib/user/msg'
    import createFile from './financialSystem/component/formTpl/createFile'
    import './lib/panel/panel'

    let _p = window.xwCommon,
        methods = {
            ready(loginPage) {

                _this.userCheck(this).then((data) => {
                    if (!data) {
                        // 未登录
                        this.showPage(false)
                        this.fullscreenLoading = false
                        return;
                    } else {
                        // 已登录
                        // global.user = $.extend({user},data)
                        this.LoginCompany = localStorage.companyName;
                        if (this.LoginCompany == 'HaoChengDa') {
                            global.title = "HR融担平台";
                        }
                        _p.setStoredProp("staff/currentQuery", data)

                        let carMenu = _.find(data.menu, (o) => {
                                return o.ref == "car"
                            }),
                            chedaiMenu = _.find(data.menu, (o) => {
                                return o.ref == "chedai"
                            })

                        _this.getUserInfo(data.staff_id).then((user) => {

                            _p.setStoredProp("staff/query", user)
                            this.user = user
                            this.setMenu(data.menu)
                            this.showPage(true)
                            this.fullscreenLoading = false
                            // _msg.start(this)

                            this.role_oper_type = user.role_oper_type;

                            //路由默认跳转做以下判断
                            if (loginPage == true || this.$route.path == "/") {
                                if (user.role_oper_type == 2 || user.role_oper_type == 3) {

                                    if (!carMenu && chedaiMenu) {
                                        this.$bus.emit('push-router', "/homePage/system")
                                    } else {
                                        this.$bus.emit('push-router', "/homePage")
                                    }
                                } else {
                                    if (carMenu) {
                                        this.$bus.emit('push-router', "/user/taskTodo")
                                    }
                                    if (!carMenu && chedaiMenu) {
                                        this.$bus.emit('push-router', "/system/update/1")
                                    }
                                }

                            }


                        }, (json) => _p.promiseErrorChecker(this, json, "获取用户信息"))

                    }

                }, (json) => _p.promiseErrorChecker(this, json, "获取权限信息"))


            },
            showPage(b) {
                if (b) {
                    this.login = b
                    $("body").addClass("skin-blue fixed")
                } else {
                    this.login = b
                    $("body").removeClass("skin-blue fixed")
                }
                this.show = true
                this.setAreaActive(this.$route.name)
            },
            setMenu(appMenu) {
                let obj = {
                        "topTodo": "top_todo",
                        "topNewOrder": "top_new_order",
                        "topSystemTab": "folder_admin",
                        "topCarTab": "car",
                        "topAdminTab": "admin",
                        "topMsg": "top_user_msg",
                        "topFastDebit": "top_csd",
                        "top_chedaiTab": "chedai",
                    },
                    vm = this
                $.each(obj, (k, v) => {
                    vm[k] = _.find(appMenu, (o) => {
                        return o.ref == v
                    })
                })
                _p.setStoredProp("topCarTab", this.topCarTab)
            },
            userSignOut() {
                let url = _p.getApiUrl("login/out")
                this.$confirm("确认要退出？", "退出登录", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fullscreenLoading = true
                    _this.userSignOut().then(() => {
                        this.showPage(false)
                        _msg.stop(this)
                        this.fullscreenLoading = false
                        this.$message({type: 'success', message: '已退出系统!'});
                        (localStorage.companyName == "HaoChengDa") ? this.$bus.emit('push-router', "/login") : this.$bus.emit('push-router', "/")
                        window.location.reload;
                    }, (json) => _p.promiseErrorChecker(this, json, "退出登录"))
                })
            },
            backLogin() {
                this.showPage(false)
                this.$message.error('请重新登录!');
            },
            setAreaActive(name) {
                if(name === undefined) this.areaName = ''
                else if ('default' === name) this.areaName = "home"
                else if (name.indexOf('car') === 0) this.areaName = "car"
                else if (name.indexOf('chedai') === 0) this.areaName = "chedai"
                else this.areaName = ""

            },
            loadingPage(b) {
                this.fullscreenLoading = b
                if (!b) $("body").css({"overflow": "auto", "padding-right": 0})
            },
            resetMsg() {
                sessionStorage.removeItem('noNotifyCheck');
                // _msg.stop(this)
                // _msg.start(this)
            },
            reload() {
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    this.isRouterAlive = true;
                })
            }
        }

    export default {
        name: 'layout', methods,
        components: {loginArea, sidebarArea, createWin, createFile},
        provide() {
            return {
                reload: this.reload,
            }
        },
        data() {
            return {
                login: false,
                show: false,
                areaName: "",
                topCarTab: false,
                topAdminTab: false,
                topSystemTab: false,
                topBackTab: false,
                isRouterAlive: false,
                taskCount: "",
                msgCount: "",
                priceCount: "",
                topNewOrder: false,
                topTodo: false,
                topNotify: false,
                topMsg: false,
                fullscreenLoading: true,
                showCreateWin: false,
                showCreateFile: false,
                user: {},
                version: global.config.version,
                viewVer: global.config.verInfo,
                year: (new Date()).getFullYear(),
                role_oper_type: "",
                LoginCompany: "",
            }
        },
        watch: {
            '$route': function (to) {
                this.setAreaActive(to.name)
            }
        },
        mounted() {
            this.fullscreenLoading = true;
            $.ajaxSetup($.extend({
                error: (err) => {
                    this.fullscreenLoading = false
                    let desc = "因为下面的原因，您的请求没有响应！请检查网络情况，或联系管理员处理！"
                    desc += "错误编号：AJAX-" + err.status
                    desc += " （" + err.statusText + "）"
                    if (process.env.NODE_ENV === "development") {
                        console.error(err)
                        this.$alert(desc, "网络错误")
                    } else {
                        this.$alert(desc, "断网了？", {
                            confirmButtonText: "刷新",
                            type: "error",
                            callback() {
                                location.reload(true)
                            }
                        })
                    }

                }
            }, _p.ajaxCfg))
            this.$bus
                .on("loginOK", this.ready)
                .on("needLogin", this.backLogin)
                .on("loading", this.loadingPage)
                .on("resetMsg", this.resetMsg)
            this.ready()
        },
        beforeDestroy() {
            delete window.xwCommon
            delete window.xwStored
        }
    };


</script>

<style>
    .main-header .navbar-custom-menu {
        margin-right: 15px;
    }

    .qrcode-menu .qrcode {
        padding: 5px;
    }

    .qrcode-menu .qrcode img {
        width: 160px;
    }

    .cd-todoTable .label {
        margin: 5px;
        display: inline-block;
        float: left;
    }

    .sidebar-toggle {
        font-size: 14px;
    }

    .has-disabledField .is-disabled .el-input__inner {
        background-color: #fff;
        color: #1f2d3d;
    }

    .el-upload__input {
        display: none !important;
    }

    .el-loading-mask {
        z-index: 1950;
    }

    .logo-lg {
        background: url(../static/img/logo.png) no-repeat 12px 6px;
        height: 30px;
        margin-top: 10px;
    }

    @media print {
        @page {
            size: A4 landscape;
        }

        .el-col {
            width: 100% !important;
        }

        .main-sidebar {
            display: none;
        }

        .content-wrapper {
            margin-left: 1cm !important;
        }

        .el-form-item {
            margin-bottom: .5em !important;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner:before {
            content: "√";
            font-size: 18px;
            width: 20px;
            display: block;
            line-height: 20px;
            color: #000;
            text-align: center;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner:after {
            display: none !important;
        }

        .el-form-item__error {
            display: none !important;
        }

        i.el-input__icon, i.fa {
            display: none !important;
        }

        .el-loading-mask {
            display: none !important;
        }

        .imgBox {
            height: auto !important;
        }

        .imgBox p {
            position: relative !important;
        }
    }
</style>


// WEBPACK FOOTER //
// chedai.vue?3fc72ef8